@if (details.returnReasonCode) {
    <section class="return-info">
        <h3 class="return-info__heading">Return Information</h3>
        <div class="return-info__grid">
            <div>
                <span class="return-info__label">Return Date</span>
                <p class="return-info__value">{{ details.returnDate | date:'MM/dd/yyyy' }}</p>
            </div>
            <div>
                <span class="return-info__label">Return Reason Code</span>
                <p class="return-info__value">{{ details.returnReasonCode }}</p>
            </div>
            <div>
                <span class="return-info__label">Return Description</span>
                <p class="return-info__value">{{ details.returnReasonDescription }}</p>
            </div>
            <div>
                <span class="return-info__label">Retry Attempt</span>
                <p class="return-info__value">{{ details.retryAttempt ?? '--' }}</p>
            </div>
        </div>
    </section>
}
